import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { Header } from 'organisms/HeaderComponent';
import { Footer } from 'organisms/FooterComponent';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { getHeaderContentData, getHeaderData, getFooterData, isEmptyObject } from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import { DealsAndOffers } from 'organisms/DealsAndOffersLanding/';
import { SHOW_COPY_COUPON_ACTION } from 'organisms/DealsAndOffersLanding/constants/offersAndDealsConstants';
import { ChannelManager } from 'common/manager';

export const DealsPageContainer = props => {
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedFooterData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  /**
   * Method to open open disposition module
   */
  const onStartOrderClick = () => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  };

  const dispatchDealsPageAction = useDispatch();

  const copyCoupon = discountCode => {
    navigator?.clipboard?.writeText(discountCode);
    userOrderStateDispatch({ type: SHOW_COPY_COUPON_ACTION });
  };

  useEffect(() => {
    dispatchDealsPageAction(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': tenantReducer?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
    dispatchDealsPageAction(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
  }, [dispatchDealsPageAction, tenantReducer?.country, userParams]);

  /**
   * method to setup content data for home page config
   */
  const allReducerData = useSelector(data => {
    return {
      homePageContent: data.contentReducer.response || null,
      marketPageContent: data.marketConfigReducer.response || null,
      tenantReducerContent: data.tenantReducer || null,
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const { header = {}, footer = {} } = allReducerData.marketPageContent.headerData || {};
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
  }

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
      />
      <DealsAndOffers
        data-testid='deals-offers-container'
        copyCoupon={copyCoupon}
        onStartOrderClick={onStartOrderClick}
        {...props}
      />
      {(isEmptyObject(segmentedFooterData) && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
    </React.Fragment>
  );
};
